import React, { useEffect } from 'react';
import { getText } from '@storebrand-digital/fms-translations';

import { useFormik } from 'formik';
import { filterActions } from './reducer';
import { useAppDispatch, useAppSelector } from '../../app/store';
import { selectFilters } from './selectors';
import DropdownFilter from '../../components/DropdownFilter';
import useCategories from './hooks/useCategories';

function FilterFormCategories() {
  const dispatch = useAppDispatch();
  const filters = useAppSelector(selectFilters);
  const { data: categories, status } = useCategories();
  const formik = useFormik({
    initialValues: {
      categories: filters.categories ?? [],
    },
    enableReinitialize: true,
    onSubmit: () => {},
  });

  useEffect(() => {
    const selectedCategories = formik.values.categories ?? [];
    dispatch(filterActions.changeCategories(selectedCategories));
  }, [formik.values.categories, dispatch]);

  const handleSelectionChange = (selectedValues: (string | number)[]) => {
    formik.setFieldValue('categories', selectedValues);
  };

  const handleClear = () => {
    formik.setFieldValue('categories', []);
  };

  const transformCategoriesToOptions = () => {
    const uncategorizedOption = {
      label: getText('filter.category.blank'),
      value: 0,
      info: getText('filter.category.popover'),
    };
    const options =
      categories?.map((category) => ({
        label: getText(category.fmsKey),
        value: category.id,
      })) ?? [];
    return [...options, uncategorizedOption];
  };

  const isLoading = status === 'pending';
  const hasError = status === 'error';
  const filterTitle = getText('filter.category.title');

  return (
    <DropdownFilter
      name="categories"
      heading={filterTitle}
      title={filterTitle}
      options={transformCategoriesToOptions()}
      selectedValues={formik.values.categories}
      onSelectionChange={handleSelectionChange}
      onClear={handleClear}
      loading={isLoading}
      error={hasError ? getText('filter.category.fetchError') : undefined}
      trackId="button-dropdownfilter_produkt_type|Velg produkttype"
    />
  );
}

export default FilterFormCategories;
